export class Entidades {   
  Data: any;
  }

export class entidad {
    Entidad: string;       
    Nombre : string;
  }

export class entid {
    constructor(public Entidad: string, public Nombre: string) {}
  }

export class Transportista {
    Codigo : string;
    Descripcion : string;
  }
  
export class Transp {
    Data : any;
  }
  
/*   export class Productos {   
    Data: any;
    }
  
  export class producto {
      Entidad: string;       
      Nombre : string;
    }
  
  export class product {
      constructor(public Entidad: string, public Nombre: string) {}
    } */